import * as React from "react";

import { ReactComponent as DirectboxReceiveIcon } from "assets/images/svg/directbox-receive.svg";

import styles from "./CalculatorDetailsEmpty.module.scss";
import { AppButton } from "components/AppButton";
import { useNavigate } from "react-router";
import { ROUTER_NAMES } from "router/routerNames";

export const CalculatorDetailsEmpty: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <DirectboxReceiveIcon />
      </div>
      <div className={styles.title}>План пока не выбран</div>
      <div className={styles.description}>
        Нажмите на один из планов чтобы узнать подробности
      </div>

      <AppButton onClick={() => navigate(`${ROUTER_NAMES.CALCULATORS}/create`)} variant="siren" style={{ maxWidth: '90%', margin: 20 }}>Создать</AppButton>
    </div>
  );
};
